import { render } from "./ReadyModal.vue?vue&type=template&id=1bd54fc5&scoped=true"
import script from "./ReadyModal.vue?vue&type=script&lang=js"
export * from "./ReadyModal.vue?vue&type=script&lang=js"

import "./ReadyModal.vue?vue&type=style&index=0&id=1bd54fc5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bd54fc5"]])

export default __exports__